var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_11873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_11873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 15.6753V14.6753H12.4668C12.5223 14.6753 12.5697 14.6557 12.6088 14.6166C12.6474 14.5779 12.6668 14.5253 12.6668 14.4586V13.8753H10.3001V9.1586H12.6668V8.2086C12.6668 6.91971 12.2112 5.81971 11.3001 4.9086C10.389 3.99749 9.28899 3.54193 8.0001 3.54193C6.71121 3.54193 5.61121 3.99749 4.7001 4.9086C3.78899 5.81971 3.33343 6.91971 3.33343 8.2086V9.1586H5.7001V13.8753H3.53344C3.2001 13.8753 2.91677 13.7586 2.68344 13.5253C2.4501 13.2919 2.33344 13.0086 2.33344 12.6753V8.2086C2.33344 7.43082 2.48344 6.69749 2.78344 6.0086C3.08344 5.31971 3.48899 4.71971 4.0001 4.2086C4.51121 3.69749 5.11121 3.29193 5.8001 2.99193C6.48899 2.69193 7.22232 2.54193 8.0001 2.54193C8.77788 2.54193 9.51121 2.69193 10.2001 2.99193C10.889 3.29193 11.489 3.69749 12.0001 4.2086C12.5112 4.71971 12.9168 5.31971 13.2168 6.0086C13.5168 6.69749 13.6668 7.43082 13.6668 8.2086V14.4586C13.6668 14.803 13.5501 15.0919 13.3168 15.3253C13.0834 15.5586 12.8001 15.6753 12.4668 15.6753H8.0001ZM3.53344 12.8753H4.7001V10.1586H3.33343V12.6753C3.33343 12.7308 3.35299 12.7782 3.3921 12.8173C3.43077 12.8559 3.47788 12.8753 3.53344 12.8753ZM11.3001 12.8753H12.6668V10.1586H11.3001V12.8753Z",
    fill: "#4F0696"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.a1e0676c65cd301fcbd337cdc52a2598.svg";
export { ForwardRef as ReactComponent };